import { createModel } from '@rematch/core';
import { RootModel } from '../index';
import produce from 'immer';
import { config } from '../../../config/announceBar/config';
import { ChainId } from '../../../types/mod';

export interface AnnounceBarState {
    showBar: boolean[],
    chainId: number,
}

export const announceBar = createModel<RootModel>()({
    state: {
        showBar: new Array(config.length).fill(true),
        chainId: process.env.REACT_APP_ENV === 'production' ? ChainId.BSC : ChainId.BSCTestnet
    } as AnnounceBarState,
    reducers: {
        setShowBar: (state: AnnounceBarState, show:boolean, index:number) => produce(state, draft => {
            draft.showBar[index] = show;
        }),
        setChainId: (state: AnnounceBarState, chainId: number) => produce(state, draft => {
            draft.chainId = chainId;
        }),
    },
});
